export class AWSConstants
{
    static METRICS = [
        "UnblendedCost", "BlendedCost", "AmortizedCost",
        "NetAmortizedCost", "NetUnblendedCost", "UsageQuantity"
    ];
    static DIMENSIONS = [
        "REGION",
        "SERVICE",
        "INSTANCE_TYPE",
        "USAGE_TYPE",
        "AZ",
        "PLATFORM",
        "PURCHASE_TYPE",
        "TENANCY",
        "OPERATION",
        "RECORD_TYPE",
    ];
    static REGIONS = [
        "us-east-1",        // N. Virginia
        "us-east-2",        // Ohio
        "us-west-1",        // N. California
        "us-west-2",        // Oregon
        "af-south-1",       // Cape Town
        "ap-east-1",        // Hong Kong
        "ap-south-1",       // Mumbai
        "ap-south-2",       // Hyderabad
        "ap-southeast-1",   // Singapore
        "ap-southeast-2",   // Sydney
        "ap-southeast-3",   // Jakarta
        "ap-southeast-4",   // Melbourne
        "ap-northeast-1",   // Tokyo
        "ap-northeast-2",   // Seoul
        "ap-northeast-3",   // Osaka
        "ca-central-1",     // Central Canada
        "ca-west-1",        // Calgary
        "eu-central-1",     // Frankfurt
        "eu-central-2",     // Zurich
        "eu-west-1",        // Ireland
        "eu-west-2",        // London
        "eu-west-3",        // Paris
        "eu-north-1",       // Stockholm
        "eu-south-1",       // Milan
        "eu-south-2",       // Spain
        "me-south-1",       // Bahrain
        "me-central-1",     // UAE
        "sa-east-1",        // São Paulo
        "il-central-1",     // Tel Aviv
    ];
    static getDimensionCombinations():
        {
            name: string;
            keys: string[];
        }[]
    {
        let ans: {
            name: string;
            keys: string[];
        }[] = [];
        ans.push({
            name: "TOTAL",
            keys: []
        });
        ans.push(...AWSConstants.DIMENSIONS.map(d => { return { name: d, keys: [d] } }));
        for (let i = 0; i < AWSConstants.DIMENSIONS.length; i++)
            for (let j = i + 1; j < AWSConstants.DIMENSIONS.length; j++)
                ans.push({
                    name: `${AWSConstants.DIMENSIONS[i]}*${AWSConstants.DIMENSIONS[j]}`,
                    keys: [AWSConstants.DIMENSIONS[i], AWSConstants.DIMENSIONS[j]]
                });
        return ans;
    }
}